$(() => {
	new ArticleOffer();
});

class ArticleOffer {
	constructor() {
		this.init();
	}

	init() {
		$(document).on('click', '.js-share-offer', event => {
			event.preventDefault();

			const submitButton = $(event.currentTarget);
			const form = submitButton.closest('form');
			const action = submitButton.data('shareaction');
			const sharingContainer = $(submitButton.data('container'));
			const messageContainer = $(sharingContainer.data('message'));
			const collapseTarget = $(sharingContainer.data('collapse'));

			submitButton.prop('disabled', true);

			this.sendRequest(
				action,
				form.serialize(),
				(result) => {
					submitButton.prop('disabled', false);

					const sharingContainerResult = $(result).find('#' + sharingContainer.attr('id')).html();

					if (sharingContainerResult) {
						sharingContainer.html(sharingContainerResult);
					}
					else {
						messageContainer.html(result);

						// Close sharing and reset fields
						sharingContainer.on('hidden.bs.collapse', () => {
							sharingContainer.unbind('hidden.bs.collapse');
							sharingContainer.find('.js-reset-on-submit').each(function () {
								const inputType = $(this).attr('type');

								if (inputType == 'checkbox') {
									$(this).prop('checked', false);
								}
								else {
									$(this).val('');
								}
							});
						});
						collapseTarget.collapse('hide');

						// Fade out message
						messageContainer.children().delay(3000).slideUp();
					}
				}
			);
		});
	}

	sendRequest(action, data, callback) {
		$.ajax({
			url: action,
			data: data,
			type: 'POST',
			success: function (result) {
				if (callback) {
					callback(result);
				}
			},
		});
	}
}
